(() => {
  if (
    'replaceUniqueIdentifiers' in window &&
    typeof window['replaceUniqueIdentifiers'] === 'function'
  ) {
    return;
  }

  // Function to generate a unique ID
  function generateUniqueId() {
    return (
      'id_' +
      Date.now().toString(36) +
      '_' +
      Math.random().toString(36).substr(2, 9)
    );
  }

  // Function to replace `[uniq_identifier]` in input IDs and label `for` attributes
  function replaceUniqueIdentifiers(wrapper = document) {
    // Select all elements to replace `[uniq_identifier]` in their child labels/input ID
    const uniqNodes = wrapper.querySelectorAll('[js-generate-uniq-id]');

    if (!uniqNodes.length) {
      return;
    }

    uniqNodes.forEach((element) => {
      // Generate a new unique ID
      const uniqueId = generateUniqueId();
      const input = element.querySelector('input[id*="[uniq_identifier]"]');
      const label = element.querySelector('label[for*="[uniq_identifier]"]');

      if (!input || !label) {
        console.warn("uniq input&label pair isn't found");

        return;
      }

      // Replace `[uniq_identifier]` with the generated unique ID in the input's ID
      input.id = input.id.replace('[uniq_identifier]', uniqueId);
      label.setAttribute('for', input.id);
    });
  }

  window.replaceUniqueIdentifiers = replaceUniqueIdentifiers;
})();
